
<template>
  <div>
    <index-card :loading="all_loadings" fluid>
      <template slot="header">
        <v-col cols="12">
          <span class="white--text caption d-flex align-center">
            <v-icon class="white--text" left>mdi-cash-multiple</v-icon>
            PÁGINA DE PAGAMENTO
          </span>
        </v-col>
        <template>
          <v-btn text icon large @click="$router.push({name:'IndexPayShippings'})" exact><v-icon
            class="white--text">mdi-arrow-left</v-icon>
          </v-btn>
          <div class="d-flex flex-column justify-center align-center" v-if="driver">
            <div centered class="d-flex flex-column justify-center text-center white--text">
              <span class="text-h4 font-weight-medium">
                <div>
                  {{ driver.name || driver.data.attributes.name }}
                </div>
              </span>
            </div>
            <div class="driver-payment-info mt-2 text-center" v-if="paymentKinds.length">
              <span class="white--text caption d-block mb-1">Formas de recebimento</span>
              <div class="d-flex flex-wrap justify-center">
                <v-chip
                  v-for="kind in paymentKinds"
                  :key="kind"
                  small
                  color="white"
                  text-color="primary"
                  class="ma-1"
                >
                  <v-icon left small>{{ paymentIcon(kind) }}</v-icon>
                  {{ paymentLabel(kind) }}
                </v-chip>
              </div>
              <div v-if="hasPaymentKind('pix') && pixKey" class="white--text caption mt-2">
                Chave PIX ({{ pixKeyKindLabel }}): <b>{{ pixKey }}</b>
              </div>
              <div v-if="hasPaymentKind('deposit')" class="mt-2">
                <driver-bank-account class="mt-1"></driver-bank-account>
              </div>
            </div>
            <div v-else-if="driver" class="mt-2">
              <v-chip small outlined dark class="white--text">
                <v-icon left small>mdi-alert-circle-outline</v-icon>
                Sem forma de recebimento cadastrada
              </v-chip>
            </div>
          </div>
          <v-btn text icon large @click="getData()" exact><v-icon class="white--text">mdi-refresh</v-icon></v-btn>
        </template>

      </template>
      <template slot="subheader">
        <v-tabs v-model="shipTabs" light grow icons-and-text  background-color="blue-grey darken-1" dark v-if="driver"
        :slider-color="tabItem[shipTabs].color">
        <v-tab v-model="shipTabs" v-for="(item, index) in tabItem" :key="`tab-${index}`" ripple>
          {{ item.tabTitle }}
          <v-icon large :color="item.color">{{ item.tabIcon }}</v-icon>
        </v-tab>
  
        </v-tabs>
      </template>
      <template template slot="data_table">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col cols="12" class="py-0">
                <div class="ml-3 mb-1">
                  <v-chip small color="primary">
                    <v-icon small left>mdi-account</v-icon>
                    <span v-if="driver?.data?.attributes?.kind == 'driver'">
                      Fretes do MOTORISTA
                    </span>
                    <span v-if="driver?.data?.attributes?.kind == 'transporter'">
                      Fretes da TRANSPORTADORA
                    </span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-tabs-items v-model="shipTabs" touchless>
              <v-tab-item v-if="shipTabs == 0" :value="0">
                <div>
                  <driver-open @payed="getData()" :type_tabs="type_tabs" :selectedSolution="activeModalitySolution" :modality_id="activeModalityId"></driver-open>
                </div>
              </v-tab-item>
              <v-tab-item v-if="shipTabs == 1" :value="1">
                <div>
                  <driver-historic :type_tabs="type_tabs" :selectedSolution="activeModalitySolution" :modality_id="activeModalityId"></driver-historic>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </template>
    </index-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'ShowDriverPayShipping',
  components: {
    IndexCard: ()=>import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    DriverBankAccount: () => import('./DriverBankAccount.vue'),
    DriverOpen: () => import('./DriverOpenTransactions.vue'),
    DriverHistoric: () => import('./DriverFinancialHistoric.vue'),
  },
  data() {
    return {
      type_tabs: 0,
      driver: null,
      search: null,
      shipTabs: 0,
      tabItem: [
        { tabTitle: 'Abertos', tabIcon: 'mdi-currency-usd', color: 'info lighten-2', table_title: 'Fretes a pagar', },
        { tabTitle: 'Histórico', tabIcon: 'mdi-history', color: 'purple lighten-2', table_title: 'Histórico', },
      ],
      loading: {
        driver: false,
        open_transactions: false,
      },
      payment_map: {
        cash: 'Dinheiro',
        deposit: 'Depósito',
        pix: 'Pix',
        bill: 'Boleto',
      },
      payment_icon_map: {
        cash: 'mdi-cash',
        deposit: 'mdi-bank',
        pix: 'mdi-qrcode',
        bill: 'mdi-barcode',
      },
      pix_key_kind_map: {
        cnpj: 'CNPJ',
        email: 'E-mail',
        phone: 'Telefone',
        random: 'Aleatória',
      },
      filter: {
        modality_id: null,
      },
    }
  },
  computed: {
    ...mapState({
      activeModalitySolution: state => state.App.activeModalitySolution,
    }),
    receiptConfig() {
      const attrs = this.driver?.data?.attributes
      if (!attrs) return {}
      return attrs.transporter_receipt_config || attrs.receipt_config || {}
    },
    paymentKinds() {
      if (this.receiptConfig.kinds?.length) return this.receiptConfig.kinds
      if (this.receiptConfig.kind) return [this.receiptConfig.kind]
      return []
    },
    pixKey() {
      return this.receiptConfig.pix_key
    },
    pixKeyKindLabel() {
      return this.pix_key_kind_map[this.receiptConfig.pix_key_kind] || this.receiptConfig.pix_key_kind
    },
    all_loadings(){
      return this.loading.driver || this.loading.open_transactions
    },
  },
  methods: {
    paymentLabel(kind) {
      return this.payment_map[kind] || kind
    },
    paymentIcon(kind) {
      return this.payment_icon_map[kind] || 'mdi-cash'
    },
    hasPaymentKind(kind) {
      return this.paymentKinds.includes(kind)
    },
    getData() {
      this.filter.modality_id = this.activeModalityId
      this.getDriver()
    },
    getRetailOpenTransactions() {
      if (this.activeModalitySolution === 'retail' && this.activeModalityId) {
        this.loading.open_transactions = true
        const filters = {
          modality_ids: [this.activeModalityId],
          modality_id: this.activeModalityId,
          status: [10, 30],
        }
        Api.Shipping.indexByModel({model: 'drivers', id: this.driver.data.id, filters}).then(r=>r.data).then(data=>{
          this.driver.open_incomes = [...data]
          this.setDriver(this.driver)
        }).catch(err=>{
          console.log(err);
        }).finally(()=>{
          this.loading.open_transactions = false
        })
      }
    },
    getDriver(){
      let id = this.$route.params.id
      this.loading.driver = true
      let filter = { ...this.filter, financial: true }
      Api.Driver.show(id, filter).then(res => res.data).then(data => {
        this.driver = {...data}
        this.driver.open_incomes = [...this.driver.data.attributes.open_incomes_with_brand]

        this.getRetailOpenTransactions()
        this.setDriver(this.driver)
      }).finally(()=>{
        this.loading.driver = false
      })
    },
    ...mapActions({
      setDriver: "Driver/setDriver"
    })
  },
  mounted() {
    this.getData()
  },
  watch: {
    type_tabs() {
      this.getDriver()
    },
    activeModalitySolution(nv) {
      if (nv) {
        this.getRetailOpenTransactions()
      }
    },
    activeModalityId(nv) {
      if (nv) {
        this.getData()
      }
    },
  },
}
</script>
